import { createContext, useContext } from "react";
import type { StaffRole } from "../lib/api";

// Server-confirmed staff role for the current session, provided by StaffGate
// (set from /staff/auth). Consumers read this instead of the user-controlled
// localStorage value, so role-gated UI can't be faked from the browser console.
export const StaffRoleContext = createContext<StaffRole | null>(null);
export const useStaffRole = (): StaffRole | null => useContext(StaffRoleContext);
